/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-icon-container[_ngcontent-%COMP%]{cursor:pointer}.happ-icon-container[_ngcontent-%COMP%]:hover{background:rgba(0,0,0,.54)}.happ-icon-container[_ngcontent-%COMP%]:hover   mat-icon[_ngcontent-%COMP%]{color:#fff}.active[_ngcontent-%COMP%]{background:rgba(0,0,0,.54)}.active[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
